if (!customElements.get('nuer-judgeme-conveyor')) {
  customElements.define('nuer-judgeme-conveyor', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.playback = window.NuerReviewMotion.observePlayback(this, true);
      this.cleanupHover = window.NuerReviewMotion.observeCardHover(this, '.jm-review-item');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.refresh = this.refresh.bind(this);
      this.onFocusIn = (event) => {
        const card = event.target.closest('.jm-review-item');
        if (card && this.list?.contains(card)) {
          this.alignCard(card);
          this.setAttribute('data-focused', '');
        }
      };
      this.onFocusOut = (event) => {
        if (!event.relatedTarget?.closest('.jm-review-item')) this.removeAttribute('data-focused');
      };
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      this.reducedMotion.addEventListener('change', this.refresh);
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this, { childList: true, subtree: true, attributes: false });
      this.refresh();
    }

    setStyle(name, value) {
      if (this.style.getPropertyValue(name) !== value) this.style.setProperty(name, value);
    }

    alignCard(card) {
      const offset = card.offsetLeft - this.list.firstElementChild.offsetLeft;
      const distance = Math.max(0, this.list.scrollWidth - this.list.parentElement.clientWidth);
      this.setStyle('--nuer-review-focus', `${-Math.min(offset, distance)}px`);
    }

    refresh() {
      const list = this.querySelector('#judgeme_product_reviews .jdgm-review-list:not(.nuer-judgeme-copy)');
      if (list !== this.list) {
        this.resizeObserver.disconnect();
        this.copy?.remove();
        this.copy = null;
        this.copyContent = null;
        this.list = list;
        this.resizeObserver.observe(this);
        if (list) this.resizeObserver.observe(list);
      }
      if (!list) {
        this.removeAttribute('data-moving');
        this.playback.sync();
        this.removeAttribute('data-focused');
        return;
      }
      const cards = Array.from(list.children).filter((node) => node.classList.contains('jm-review-item'));
      const candidate = cards.length > 0 && !this.reducedMotion.matches;
      const available = list.parentElement.clientWidth;
      list.classList.toggle('nuer-judgeme-track', candidate);
      const width = list.getBoundingClientRect().width;
      const moving = candidate && available > 0 && width >= available - 1;
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      this.setStyle('--nuer-review-travel', `${-(width + gap)}px`);
      this.setStyle('--nuer-review-copy-left', `${width + gap}px`);
      const cardWidth = cards[0]?.getBoundingClientRect().width || 1;
      const duration = window.NuerReviewMotion.duration(this, width + gap, cardWidth, gap);
      this.setStyle('--nuer-review-duration', `${duration}s`);
      this.toggleAttribute('data-moving', moving);
      this.playback.sync();
      if (moving) {
        // Keep Judge.me's native list intact; the second copy is presentation only.
        const content = list.innerHTML;
        if (!this.copy || this.copyContent !== content) {
          this.copy?.remove();
          this.copy = list.cloneNode(true);
          this.copy.removeAttribute('id');
          this.copy.classList.add('nuer-judgeme-copy');
          this.copy.setAttribute('aria-hidden', 'true');
          this.copy.setAttribute('inert', '');
          this.copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          this.copyContent = content;
          list.parentElement.append(this.copy);
        }
      } else {
        this.copy?.remove();
        this.copy = null;
        this.copyContent = null;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.reducedMotion?.removeEventListener('change', this.refresh);
      this.cleanupHover?.();
      this.playback?.disconnect();
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      this.copy?.remove();
      this.copy = null;
      this.observer = null;
    }
  });
}
